export const examples = {
  javascript: {
    language: "JavaScript",
    example: `/**
* JSDoc example
* @param {Object} block - The block to be processed.
* @param {string} cls - The class name to be added to the block.
*/
function $initHighlight(block, cls) {
  try {
    if (cls.search(/\\bno\\-highlight\\b/) != -1) {
      return process(block, true, 0x0F) + \` class="\${cls}"\`;
    }
  } catch (e) {
    /* handle exception */
  }
  for (var i = 0 / 2; i <= classes.length; i++) {
    if (checkCondition(classes[i]) === undefined)
      console.log('undefined');
  }

  return (
    <div>
      <web-component>{block}</web-component>
    </div>
  )
}
`,
  },
  css: {
    language: "CSS",
    example: `@font-face {
  font-family: Chunkfive; src: url('Chunkfive.otf');
}

body, .usertext {
  color: #F0F0F0; background: #600;
  font-family: Chunkfive, sans;
  --heading-1: 30px/32px Helvetica, sans-serif;
}

@import url(print.css);
@media print {
  a[href^=http]::after {
    content: attr(href)
  }
}`,
  },
  markup: {
    language: "HTML",
    example: `<!DOCTYPE html>
<title>Title</title>

<style>body {width: 500px;}</style>

<script type="application/javascript">
  function $init() {return true;}
</script>

<body>
  <p checked class="title" id='title'>Title</p>
  <!-- here goes the rest of the page -->
</body>`,
  },
  java: {
    language: "Java",
    example: `// https://howtodoinjava.com/puzzles/fizzbuzz-solution-java/
IntStream.rangeClosed(1, 100)
  .mapToObj(
    i -> i % 5 == 0 ?
    (i % 7 == 0 ? "FizzBuzz" : "Fizz") :
    (i % 7 == 0 ? "Buzz" : i)
  )
  .forEach(
    System.out::println
  );`,
  },
  php: {
    language: "PHP",
    example: `// https://joshtronic.com/2014/08/24/fizz-buzz-in-php/
for ($i = 1; $i <= 100; $i++) {
  $output = '';

  if ($i % 3 == 0) {
    $output .= 'Fizz';
  }
  if ($i % 5 == 0) {
    $output .= 'Buzz';
  }
  if (!$output) {
    $output = $i;
  }

  echo $output;
}`,
  },
  python: {
    language: "Python",
    example: `def fizzbuzz(n):

    if n % 3 == 0 and n % 5 == 0:
        return 'FizzBuzz'
    elif n % 3 == 0:
        return 'Fizz'
    elif n % 5 == 0:
        return 'Buzz'
    else:
        return str(n)

print "\\n".join(fizzbuzz(n) for n in xrange(1, 21))`,
  },
  reason: {
    language: "Reason",
    example: `type schoolPerson = Teacher | Director | Student(string);

let greeting = person =>
  switch (person) {
  | Teacher => "Hey Professor!"
  | Director => "Hello Director."
  | Student("Richard") => "Still here Ricky?"
  | Student(anyOtherName) => "Hey, " ++ anyOtherName ++ "."
  };`,
  },
  markdown: {
    language: "Markdown",
    example: `abcdefghijklmnopqrstuvwxyz
ABCDEFGHIJKLMNOPQRSTUVWXYZ
 0123456789 (){}[]
 +-/= .,;:!? #&$%@ß|^~
 
**abcdefghijklmnopqrstuvwxyz**
**ABCDEFGHIJKLMNOPQRSTUVWXYZ**
**0123456789 (){}[]**
**+-/= .,;:!? #&$%@ß|^~**

*abcdefghijklmnopqrstuvwxyz*
*ABCDEFGHIJKLMNOPQRSTUVWXYZ*
*0123456789 (){}[]*
*+-/= .,;:!? #&$%@ß|^~*

## Ligatures:
<!-- -- != := === >= >- >=>
|-> -> <$> </> #[ |||> |= 
~@ ~- ~=
`,
  },
} as const;

export type Language = keyof typeof examples;
export type Example = (typeof examples)[Language];
